<template>
  <div>
    <spinner-round :isLoading="loading"></spinner-round>
    <sticky class="page-header sticky-page-header page-header--new" :back-button="true">
      <span slot="left-title">Création d'une Vente Externe</span>
    </sticky>
    <div class="columns is-gapless has-bg-light is-padding">
      <div class="column is-8 is-8-widescreen is-padding-right">
        <div class="has-bg-white is-radius-large is-border">
          <form @submit.prevent.stop="submit()">
            <div class="columns is-multiline is-margin-top-small">
              <div class="column is-padding-bottom-xsmall">
                <div class="columns">
                  <div class="column">
                    <h3 class="title is-2">Acheteur</h3>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <v-input id="buyerFirstName" name="buyerFirstName" @input="val => sale.buyer.first_name = val"
                            :model="sale.buyer.first_name" label="Prénom de l'acheteur" :errors-bag="errors"
                            data-vv-value-path="val" v-validate="'min:2'"
                            data-vv-as="Prénom">
                    </v-input>
                  </div>
                  <div class="column">
                    <v-input id="buyerLastName" name="buyerLastName" @input="val => sale.buyer.last_name = val"
                            :model="sale.buyer.last_name" label="Nom de l'acheteur"
                            :errors-bag="errors" data-vv-value-path="val" v-validate="'min:2'"
                            data-vv-as="Nom">
                    </v-input>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label class="label">Adresse</label>
                    <GmapAutocomplete @place_changed="getAddressData" class="input" :selectFirstOnEnter="true"></GmapAutocomplete>
                  </div>
                  <div class="column">
                    <v-input id="buyerEmail" name="buyerEmail" @input="val => sale.buyer.email = val"
                            :model="sale.buyer.email" label="Email de l'acheteur"
                            v-validate="'email'" :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Référence">
                    </v-input>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label class="label">Téléphone de l'acheteur</label>
                    <the-mask :mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'"
                              v-model="sale.buyer.phone" @input="val => sale.buyer.phone = val"
                              id="buyerPhone" name="buyerPhone" class="input" />
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <h3 class="title is-2">Vendeur</h3>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <v-input id="sellerFirstName" name="sellerFirstName" @input="val => sale.seller.first_name = val"
                            :model="sale.seller.first_name" label="Prénom du vendeur" v-validate="'min:2'"
                            :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Nom">
                    </v-input>
                  </div>
                  <div class="column">
                    <v-input id="sellerLastName" name="sellerLastName" @input="val => sale.seller.last_name = val"
                            :model="sale.seller.last_name" label="Nom du vendeur" v-validate="'min:2'"
                            :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Prénom">
                    </v-input>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <v-input id="sellerCompany" name="sellerCompany" @input="val => sale.seller.company = val"
                            :model="sale.seller.company" label="Société du vendeur"
                            :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Référence">
                    </v-input>
                  </div>
                  <div class="column">
                    <v-input id="sellerEmail" name="sellerEmail" @input="val => sale.seller.email = val"
                            :model="sale.seller.email" label="Email du vendeur" v-validate="'email'"
                             :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Email">
                    </v-input>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label class="label">Téléphone du vendeur</label>
                    <the-mask :mask="$configs.COUNTRY === 'FRA' ? '## ## ## ## ##' : '####################'"
                              v-model="sale.seller.phone" @input="val => sale.seller.phone = val"
                              id="sellerPhone" name="sellerPhone" class="input" />
                  </div>
                </div>

                <div class="columns">
                  <div class="column">
                    <h3 class="title is-2">Information de vente</h3>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <label class="label">Date de Vente</label>
                    <div class="field has-addons">
                      <div class="control">
                        <a class="button is-square is-static is-border is-min-width-0">
                          <span class="icon"><i class="fas fa-calendar-alt"></i></span>
                        </a>
                      </div>
                      <div class="control is-expanded has-icons-right">
                        <flat-pickr type="date" class="input" v-model="sale.sale_date" :config="dateConfig"
                                  v-validate="''"></flat-pickr>
                      </div>
                      <div class="control">
                        <a class="button is-square is-radiusless" @click="sale.sale_date = null">
                          <i class="fal fa-times"></i>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="column">
                    <v-input id="sale_price" name="sale_price" @input="val => sale.sale_price = val"
                            :model="sale.sale_price" label="Prix de vente"
                            v-validate="'decimal'" :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Référence">
                    </v-input>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <v-input id="info" name="info" @input="val => sale.info = val" :model="sale.info"
                            label="Informations supplémentaire" :errors-bag="errors" data-vv-value-path="val"
                            data-vv-as="Référence" classes="textarea">
                    </v-input>
                  </div>
                </div>
              </div>
              <div class="column is-12 is-margin-top is-paddingless-left is-paddingless-rigt is-border-top columns">
                <div class="column is-6">
                  <a @click="$router.goBack(route)" class="button has-bg-white is-uppercase is-fullwidth">
                    <span>Annuler</span>
                  </a>
                </div>
                <div class="column is-6">
                  <button class="button is-success is-uppercase is-fullwidth has-text-white"
                    :class="{'is-loading':loading}"
                    type="submit"
                    :disabled="loading">
                    <span v-if="loading"><i class="fal fa-spinner-third"></i></span>
                    <span v-else>Valider</span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { isEmpty } from 'lodash'
  import moment from 'moment'

  const emptyExt = {
    buyer: {},
    seller: {},
    sale_date: new Date(),
    sale_price: null,
    info: null
  }

  export default {
    name: 'ExternalEdit',
    data () {
      return {
        loading: false,
        lot: null,
        dateConfig: {
          altInput: true,
          altFormat: 'j M Y H:i',
          dateFormat: 'Z',
          time_24hr: true,
          enableTime: true
        },
        currentUser: null,
        sale: {},
        route: this.$route
      }
    },
    computed: {
      lotPk () {
        return this.$route.params.id
      }
    },
    methods: {
      submit () {
        let sale = this.sale
        if (isEmpty(sale.buyer)) {
          delete sale['buyer']
        }
        if (isEmpty(sale.seller)) {
          delete sale['seller']
        }
        this.$api.lotService.postExternal(this.lotPk, sale).then(res => {
          this.$notify({
            type: 'is-success',
            text: 'La vente externe a bien été créée'
          })
          this.$router.push({name: 'LotVue', params: {id: this.lotPk}})
        }).catch(() => {
          this.$notify({
            type: 'is-danger',
            text: 'Erreur lors de l\'ajout de la vente externe.'
          })
        })
      },
      validate (cb) {
        this.$validator.validateAll().then((result) => {
          cb(result)
        })
      },
      setCurrentUser (user) {
        this.currentUser = user
      },
      getAddressData (value) {
        let newAddress = {}
        value.address_components.forEach((el, idx) => {
          newAddress[el.types[0]] = el.long_name
        })
        this.$set(this.sale.buyer, 'zip_code', newAddress.postal_code || '00000')
        this.$set(this.sale.buyer, 'city', newAddress.locality)
      }
    },
    created () {
      this.sale = Object.assign({}, emptyExt)
      this.sale.sale_date = moment().format('DD/MM/YYYY')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/lot/ExternalEdit.vue